import React, { useEffect, useState } from 'react';
import CoinsSwapIcon from 'app/components/Icons/CoinsSwapIcon';
import BankIcon from 'app/components/Icons/BankIcon';
import ManatIcon from 'app/components/Icons/ManatIcon';
import GlobusIcon from 'app/components/Icons/GlobusIcon';
import SwitchIcon from 'app/components/Icons/SwitchIcon';
import CoinsStackedIconSelect from 'app/components/Icons/CoinsStackedIconSelect';
import WalletIconSelect from 'app/components/Icons/WalletIconSelect';
import SaleIcon from 'app/components/Icons/SaleIcon';

import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useMediaQuery } from '@mui/material';
import { getTheme } from 'app/components/ThemeProvider/theme';
import format from 'date-fns/format';
import LogoutIcon from 'app/components/Icons/LogoutIcon';

interface Props {
  amounts?: any;
  setAmounts?: any;
}
const useEmployeesTable = (props: Props) => {
  const theme = getTheme('light');

  const { amounts, setAmounts } = props;

  const [btnId, setBtnId] = useState(1);
  const [value, setValue] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeAnchor, setActiveAnchor] = useState('');
  const [selectedWorkerId, setSelectedWorkerId] = useState(null);

  const [isCheckAll, setIsCheckAll] = useState(false);

  const [saveTemplate, setSaveTemplate] = useState(false);
  const [successModal, setSuccesModal] = useState(false);

  const navigate = useNavigate();

  const location = useLocation();
  const lang = location.pathname.substring(0, 3);

  const [total, setTotal] = useState(0);

  const [searchParams] = useSearchParams();
  const pageType = searchParams.get('type');
  const pageSubpage = searchParams.get('subpage');

  const isUnEmployeList = pageSubpage === 'employee-deleted';
  const isEmployeList = pageType === 'employee-table' && pageSubpage !== 'employee-deleted';

  const { control, register } = useForm();

  const tabletScreen = useMediaQuery(theme.breakpoints.down(768));
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [firstFocused, setFirstFocused] = useState(false);
  const [secondFocused, setSecondFocused] = useState(false);

  const [resNextDate, setNextResDate] = useState('');
  const [resEndDate, setEndResDate] = useState('');
  const [resDate, setResDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const onFocusNext = () => {
    setFirstFocused(true);
  };
  const onFocusEnd = () => {
    setSecondFocused(true);
  };
  const handlerBlur = () => {
    setFirstFocused(false);
    setSecondFocused(false);
  };

  const handleMenuClick = (event: any, id: string) => {
    setAnchorEl(event.currentTarget);
    setSelectedWorkerId(id);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (e: any, amount: string) => {
    const { id, checked } = e.target;
    setAmounts([...amounts, [+id, amount]]);
    if (!checked) {
      setAmounts(amounts?.filter((item: any) => item[0] !== +id));
      if (amounts?.length < 6) {
        setIsCheckAll(false);
      }
    } else if (amounts?.length === 6) {
      setIsCheckAll(true);
    }
  };

  const handleSelectAll = (e: any) => {
    setIsCheckAll(!isCheckAll);
    setAmounts(tableRow.map((row) => [+row.id, row.amount]));
    if (isCheckAll) {
      setAmounts([]);
    }
  };

  const handleCancel = () => {
    setAmounts([]);
    setIsCheckAll(false);
  };

  useEffect(() => {
    if (anchorEl !== null) {
      setActiveAnchor(anchorEl.getAttribute('aria-controls'));
    }
  }, [anchorEl]);

  useEffect(() => {
    if (amounts?.length < tableRow.length) {
      setIsCheckAll(false);
    } else if (amounts?.length === tableRow.length) {
      setIsCheckAll(true);
    }
    setTotal(amounts?.reduce((accumulator: number, subarray: [number, string]) => accumulator + +subarray[1], 0));
  }, [amounts]);

  const filterBtns = [
    { id: 1, title: 'Yeni ödəniş', route: 'new-payments' },
    { id: 2, title: 'İşçi siyahisi', route: 'employee-table' },
    { id: 3, title: 'Ödənişlərin tarixçəsi', route: 'payments-history' },
  ];

  const options = [
    { value: 'Öz hesablarım arasında', label: 'Öz hesablarım arasında', icon: <CoinsSwapIcon /> },
    { value: 'Bankdaxili', label: 'Bankdaxili', icon: <BankIcon /> },
    { value: 'Ölkədaxili', label: 'Ölkədaxili', icon: <ManatIcon /> },
    { value: 'Ölkəxarici', label: 'Ölkəxarici', icon: <GlobusIcon /> },
    { value: 'Konvertasiya', label: 'Konvertasiya', icon: <SwitchIcon sx={{ width: '20px', height: '20px' }} /> },
    { value: 'Ədv ödənişi', label: 'Ədv ödənişi', icon: <CoinsStackedIconSelect /> },
    { value: 'Büdcə ödənişi', label: 'Büdcə ödənişi', icon: <WalletIconSelect /> },
    { value: 'Kredit ödənişi', label: 'Kredit ödənişi', icon: <SaleIcon /> },
  ];

  const onChange = () => {
    setValue(value);
  };

  const handleChangePageType = (id: number) => {
    setBtnId(id);
    navigate(`${lang}/salary?type=${filterBtns[id - 1].route}`);
  };

  const handlerNextDate = (startDate_: any) => {
    setResDate(startDate_);
    setNextResDate(format(startDate_, 'dd/MM/yyyy'));
    handlerBlur();
  };
  const handlerEndDate = (endDate_: any) => {
    setEndDate(endDate_);
    setEndResDate(format(endDate_, 'dd/MM/yyyy'));
    handlerBlur();
  };
  const handleNextPage = () => {
    navigate(`${lang}/salary?type=payment-details`);
  };

  const tableRow: any[] = [
    {
      id: '1',
      name: 'Turgay Gasimli Adil',
      iban: 'AZ23NICB00600670125209001AZN',
      expDate: '12/2024',
      status: 'Aktiv',
    },
    {
      id: '2',
      name: 'Turgay Gasimli Adil',
      iban: 'AZ23NICB00600670125209001AZN',
      expDate: '12/2024',
      status: 'Blocked',
    },
    {
      id: '3',
      name: 'Turgay Gasimli Adil',
      iban: 'AZ23NICB00600670125209001AZN',
      expDate: '12/2024',
      status: 'Closed',
    },
    {
      id: '4',
      name: 'Turgay Gasimli Adil',
      iban: 'AZ23NICB00600670125209001AZN',
      expDate: '12/2024',
      status: 'Closed',
    },
  ];
  const tableHeader = [
    {
      id: '1',
      name: 'İşçinin A.S.A',
    },
    {
      id: '2',
      name: 'Hesab nömrəsi / IBAN',
    },
    {
      id: '3',
      name: 'Kartın bitmə tarixi',
    },
    {
      id: '4',
      name: 'Kartın statusu',
    },
  ];

  const details = [
    {
      title: isUnEmployeList ? 'Siyahıya qaytar' : 'Siyahıdan çıxart',
      icon: <LogoutIcon color={'warning'} />,
    },
  ];

  const detailsExit = [
    {
      title: 'Siyahıya qaytar',
      icon: <LogoutIcon color={'warning'} />,
    },
  ];

  const accOptions = [
    { value: 'Alan hesab1', label: 'Alan hesab1' },
    { value: 'Alan hesab2', label: 'Alan hesab2' },
    { value: 'Alan hesab3', label: 'Alan hesab3' },
    { value: 'Alan hesab4', label: 'Alan hesab4' },
  ];

  return {
    filterBtns,
    selectedWorkerId,
    btnId,
    setBtnId,
    options,
    value,
    onChange,
    tableHeader,
    tableRow,
    details,
    anchorEl,
    activeAnchor,
    setActiveAnchor,
    handleMenuClick,
    handleClose,
    isCheckAll,
    setIsCheckAll,
    handleChangePageType,
    handleClick,
    handleSelectAll,
    handleCancel,
    amounts,
    saveTemplate,
    setSaveTemplate,
    successModal,
    setSuccesModal,
    pageType,
    handleNextPage,
    total,
    accOptions,
    control,
    register,
    tabletScreen,
    smallScreen,
    handlerBlur,
    onFocusNext,
    onFocusEnd,
    handlerNextDate,
    handlerEndDate,
    setResDate,
    setEndDate,
    resNextDate,
    resEndDate,
    resDate,
    endDate,
    firstFocused,
    secondFocused,
    detailsExit,
    pageSubpage,
    isEmployeList,
    isUnEmployeList,
  };
};

export default useEmployeesTable;
